import { renderTFText } from './adapter.fabric';
/** Thin shell, no vendor import — at migration, only this import line changes. */ var TFText = function TFText(props) {
    return renderTFText(props);
};
export default TFText;
